import React from 'react'
import type { MysterySelection } from '@mobi/betslip/types'
import { PoolCodes } from '@core/Data/Racing/poolcode'
import { PlaceText } from '@core/Areas/Quickbet/Components/BetSelectionInfo/Components/BetInfoHeader/Components/Common/PlaceText'
import { SelectionInfo } from '@core/Areas/Quickbet/Components/BetSelectionInfo/Components/Common/SelectionInfo'
import { getAcceptorsFromMysteryBetLine, parseMysterySelectionString } from '../helpers'

const enum LocalConstants {
  AllWays = ' (Allways)',
  InOrder = ' (In Order)',
}

export const MysteryComboSelection: React.FC<{
  selection: MysterySelection
}> = ({ selection }) => {
  if (!selection || !selection.bets || selection.bets.length === 0) {
    return null
  }

  return (
    <>
      {selection.bets[0].betLines.map(betline => (
        <BetLineSelection
          mysteryOption={selection.mysteryOption}
          betLine={betline}
          key={betline.poolCode}
        />
      ))}
    </>
  )
}

// ===============
// Local Component
// ===============

const BetLineSelection: React.FC<{
  mysteryOption: number
  betLine: NonNullable<MysterySelection['bets']>[0]['betLines'][0]
}> = ({ mysteryOption, betLine }) => {
  const isAlways =
    betLine.poolCode === PoolCodes.Quinella ||
    (betLine.poolCode === PoolCodes.Trifecta && mysteryOption === 10)

  const acceptors = getAcceptorsFromMysteryBetLine(betLine)
  const parsed = parseMysterySelectionString(betLine.selections, isAlways, acceptors)

  let displayValue = <span>{betLine.selections}</span>
  let suffix = ''

  if (betLine.poolCode === PoolCodes.Win) {
    displayValue = <span>{parsed['1st']}</span>
  } else if (betLine.poolCode === PoolCodes.Trifecta) {
    if (mysteryOption === 10) {
      suffix = LocalConstants.AllWays
      displayValue = <span>{parsed['ALLWAYS']}</span>
    } else {
      suffix = LocalConstants.InOrder
    }
  } else if (betLine.poolCode === PoolCodes.Exacta) {
    suffix = LocalConstants.InOrder
  }

  return (
    <SelectionInfo
      leftSlot={<PlaceText text={betLine.poolCode} />}
      text={
        <>
          {displayValue}
          {suffix}
        </>
      }
      rightSlot={
        <span>
          {betLine.poolCode === PoolCodes.Win ? (
            <span>Div x{betLine.dividend}</span>
          ) : (
            <span>Flexi {betLine.dividend * 100}%</span>
          )}
        </span>
      }
    />
  )
}
